import { t } from "../i18n"
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["query", "item", "previousButton", "nextButton", "status"]
  static values = { pageSize: { type: Number, default: 10 } }

  connect() {
    this.page = 1
    this.apply()
  }

  search() {
    this.page = 1
    this.apply()
  }

  previous() {
    if (this.page > 1) {
      this.page -= 1
      this.apply()
    }
  }

  next() {
    if (this.page < this.totalPages) {
      this.page += 1
      this.apply()
    }
  }

  apply() {
    const query = (this.hasQueryTarget ? this.queryTarget.value : "").trim().toLowerCase()
    const matches = this.itemTargets.filter((item) => item.dataset.companyName.includes(query))
    const pageSize = this.pageSizeValue

    this.totalPages = Math.max(1, Math.ceil(matches.length / pageSize))
    this.page = Math.min(this.page, this.totalPages)

    this.itemTargets.forEach((item) => item.classList.add("hidden"))
    matches.slice((this.page - 1) * pageSize, this.page * pageSize).forEach((item) => item.classList.remove("hidden"))

    if (this.hasPreviousButtonTarget) this.previousButtonTarget.disabled = this.page <= 1
    if (this.hasNextButtonTarget) this.nextButtonTarget.disabled = this.page >= this.totalPages
    if (this.hasStatusTarget) {
      this.statusTarget.textContent = matches.length === 0
        ? t("javascript.controllers.company_switcher_controller.no_companies_found")
        : t("javascript.controllers.company_switcher_controller.page_of", { page: this.page, total: this.totalPages })
    }
  }
}
